import styled from "@emotion/styled";
import IconWrapper from "metabase/components/IconWrapper";

export const IconContainer = styled(IconWrapper)`
  padding: 0.5rem;
  margin-right: 0.5rem;
`;
